import {
  FETCH_ALL_ORGANIZATION_TYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_ORGANIZATION_TYPES](state, organizationTypes) {
    state.organizationTypes = organizationTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationType/mutations.js